<template>
    <div
        class="edit-mode"
        :style="{ 'height': toolbarHeight + 'px' }"
    >
        <v-toolbar
            :height="toolbarHeight"
            :class="{ 'is-fixed__left': tourWidgets.includes(type) }"
            color="elevation-1"
            width="100%"
        >
            <v-toolbar-title class="pl-4">
                <span class="h2 widget-title text-uppercase">
                    {{ widgetTitle }}
                </span>
                <v-toolbar-title class="widget-subtitle habiteo-body-2">
                    Mode edition
                </v-toolbar-title>
            </v-toolbar-title>
            <v-spacer/>
            <v-row no-gutters>
                <v-col cols="12">
                    <div class="d-flex justify-end">
                        <!-- POI management button -->
                        <div class="pa-4" v-if="type == 'krpano'">
                            <v-btn
                                depressed
                                :loading="isLoading"
                                :disabled="isLoading || !hasPOI"
                                class="habiteo-body-2 blue darken-2"
                                @click.prevent="togglePoiSidebar"
                            >
                                <v-icon>
                                    icon-settings
                                </v-icon>
                                Gestion POI
                            </v-btn>
                        </div>
                        <!-- /POI management button -->

                        <!-- Hotspot management button -->
                        <div class="pa-4">
                            <v-btn
                                depressed
                                :loading="isLoading"
                                :disabled="isLoading || !hasHotspot"
                                class="habiteo-body-2 blue darken-2"
                                @click.prevent="toggleProgramHotspotSidebar"
                            >
                                <v-icon>
                                    icon-settings
                                </v-icon>
                                Gestion hotspot
                            </v-btn>
                        </div>
                        <!-- /Hotspot management button -->

                        <!-- View management button -->
                        <div class="pa-4">
                            <v-btn
                                depressed
                                :loading="isLoading"
                                :disabled="isLoading"
                                class="habiteo-body-2 blue darken-2"
                                @click.prevent="toggleEditView"
                            >
                                <v-icon>
                                    icon-settings
                                </v-icon>
                                Gestion vue
                            </v-btn>
                        </div>
                        <!-- /View management button -->
                    </div>
                </v-col>
            </v-row>
        </v-toolbar>

        <!-- Manage view card -->
        <v-slide-x-transition>
            <v-card
                v-show="isEditingView"
                width="370"
                class="edit-mode-cta right-fixed mt-12"
            >
                <v-container
                    fluid
                    class="grey lighten-5"
                >
                    <v-row
                        no-gutters
                        class="pr-4 pl-4 pt-6 pb-6"
                    >
                        <v-col
                            cols="12"
                            class="pb-2"
                        >
                            <h2>
                                Gestion de la vue
                            </h2>
                        </v-col>
                        <v-col cols="12">
                            Modifier l'angle de vue, le zoom et l'orientation de la vue puis sélectionner les éléments que vous souhaitez enregistrer.
                        </v-col>
                        <v-col cols="12">
                            <v-row no-gutters>
                                <div class="pr-4">
                                    <v-checkbox
                                        v-model="metadataCheckbox"
                                        value="viewAngle"
                                        label="Angle"
                                    />
                                </div>

                                <div class="pr-4">
                                    <v-checkbox
                                        v-model="metadataCheckbox"
                                        value="zoomFactor"
                                        label="Zoom"
                                    />
                                </div>

                                <div
                                    v-if="!tourWidgets.includes(type) || type ==='drone-floor-view'"
                                    class="pr-4"
                                >
                                    <v-checkbox
                                        v-model="metadataCheckbox"
                                        value="north"
                                        label="Orientation"
                                    />
                                </div>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-right"
                        >
                            <v-btn
                                depressed
                                small
                                class="text-none green accent-1 green-text text-darken-2"
                                :disabled="metadataCheckbox.length === 0"
                                @click.stop="dialogs['metadata'] = true"
                            >
                                Enregistrer
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-slide-x-transition>
        <!-- Manage view card -->

        <!-- Hotspot sidebar -->
        <v-navigation-drawer
            v-if="hasHotspot"
            v-model="isEditingHotspot"
            class="edit-sidebar pa-4"
            absolute
            hide-overlay
            stateless
            scroll-target="#hotspot-scroll"
        >
                <v-list class="edit-sidebar-header">
                    <v-list-item>
                        <span class="global-nav font-weight-bold">
                            Gestion des Hotspots
                        </span>
                    </v-list-item>
                    <v-list-item class="pt-2">
                        <span class="habiteo-body-2 subtitle">
                            Editer la position de vos hotspots
                        </span>
                    </v-list-item>
                    <v-list-item class="pt-4">
                        <v-btn
                            depressed
                            class="text-none habiteo-body-2 green accent-1 green-text text-darken-2"
                            :disabled="hotspotsToSave.length === 0"
                            @click.prevent="saveHotspots"
                        >
                            Enregistrer les modifications
                        </v-btn>
                    </v-list-item>
                </v-list>

                <v-divider class="mt-4"/>

                <v-sheet
                    id="hotspot-scroll"
                    class="overflow-y-auto"
                    :max-height="listHeight"
                >
                    <v-list class="pt-4">
                        <v-list-item
                            v-for="(hotspot, index) in krpanoHotspot"
                            v-show="hotspot.type !== 'poi' && hotspot.type"
                            class="pt-2"
                            :key="index"
                        >
                            <v-hover v-slot="{hover}">
                                <v-card
                                    class="pt-4 pb-4 pr-2 pl-2"
                                    color="grey lighten-3"
                                    width="100%"
                                    :elevation="hover ? 3 : 0"
                                    :class="{
                                        'on-hover': hover,
                                        'border': index === activeHotspot
                                    }"
                                    @click.prevent="selectHotspot(index)"
                                >
                                    <v-row no-gutters class="align-center">
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center"
                                        >
                                            <span class="icon-holder">
                                                <div
                                                    v-if="hotspot.image"
                                                    class="rounded"
                                                    :style="{ 'backgroundImage': 'url(' + hotspot.image + ')' }"
                                                />
                                                <div
                                                    v-else-if="hotspot.icon"
                                                    class="rounded"
                                                    :style="{ 'backgroundImage': 'url('+ hotspot.icon + ')' }"
                                                />
                                            </span>
                                        </v-col>
                                        <v-col :cols="index === activeHotspot ? 8 : 10">
                                            <span class="habiteo-body-2">
                                                {{ hotspot.name }}
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="2"
                                            class="d-flex justify-end"
                                        >
                                            <v-tooltip 
                                                v-if="index === activeHotspot"
                                                content-class="left"
                                                left
                                                color="amber white-text accent-3"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        depressed
                                                        color="amber accent-3"
                                                        @click.stop="resetHotspotPosition(index)"
                                                    >
                                                        <v-icon color="white">
                                                            icon-reset-position
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Réinitialiser position
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-hover>
                        </v-list-item>
                    </v-list>
                </v-sheet>
        </v-navigation-drawer>
        <!-- Hotspot sidebar -->

        <!-- POI sidebar -->
          <v-navigation-drawer
            v-if="hasPOI"
            v-model="isEditingPOI"
            class="edit-sidebar pa-4"
            app
            absolute
            hide-overlay
            stateless
            scroll-target="#poi-scroll"
        >
                <v-list class="edit-sidebar-header">
                    <v-list-item>
                        <span class="global-nav font-weight-bold">
                            Gestion des POI
                        </span>
                    </v-list-item>
                    <v-list-item class="pt-2">
                        <span class="habiteo-body-2 subtitle">
                            Editer la position de vos POI
                        </span>
                    </v-list-item>
                    <v-list-item class="pt-4">
                        <v-btn
                            depressed
                            class="text-none habiteo-body-2 green accent-1 green-text text-darken-2"
                            :disabled="hotspotsToSave.length === 0"
                            @click.prevent="saveHotspots"
                        >
                            Enregistrer les modifications
                        </v-btn>
                    </v-list-item>
                </v-list>
                <v-divider class="mt-4"/>
                 <v-sheet
                    id="poi-scroll"
                    class="overflow-y-auto"
                    :max-height="listHeight"
                >
                    <v-list class="pt-4">
                        <v-list-item
                            v-for="(hotspot, index) in krpanoHotspot"
                            v-show="hotspot.type === 'poi'"
                            class="pt-2"
                            :key="index"
                        >
                            <v-hover v-slot="{hover}">
                                <v-card
                                    class="pt-4 pb-4 pr-2 pl-2"
                                    color="grey lighten-3"
                                    width="100%"
                                    :elevation="hover ? 3 : 0"
                                    :class="{ 'on-hover': hover, 'border': index === activeHotspot }"
                                    @click.prevent="selectHotspot(index);"
                                >
                                    <v-row no-gutters class="align-center">
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center"
                                        >
                                            <span class="icon-holder">
                                                <div
                                                    v-if="hotspot.image"
                                                    class="rounded"
                                                    :style="{ 'backgroundImage': 'url(' + hotspot.image + ')' }"
                                                />
                                                <div
                                                    v-else-if="hotspot.icon"
                                                    class="rounded"
                                                    :style="{ 'backgroundImage': 'url('+ hotspot.icon + ')' }"
                                                />
                                            </span>
                                        </v-col>
                                        <v-col :cols="index === activeHotspot ? 8 : 10">
                                            <span class="habiteo-body-2">
                                                {{ hotspot.name }}
                                            </span>
                                        </v-col>
                                        <v-col
                                            v-if="index === activeHotspot"
                                            cols="2"
                                            class="d-flex justify-end"
                                        >
                                            <v-tooltip 
                                                content-class="left"
                                                left
                                                color="amber white-text accent-3"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        depressed
                                                        color="amber accent-3"
                                                        @click.stop="resetHotspotPosition(index)"
                                                    >
                                                        <v-icon color="white">
                                                            icon-reset-position
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Réinitialiser position
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-hover>
                        </v-list-item>
                    </v-list>
                </v-sheet>
        </v-navigation-drawer>
        <!-- POI sidebar -->

        <!-- Metadata dialog -->
        <v-dialog
            transition="dialog-top-transition"
            max-width="500"
            v-model="dialogs['metadata']"
        >
            <v-card class="pa-6">
                <h2 class="font-weight-bold pb-4">
                    Sauvegarder les modifications
                </h2>
                <v-card-text>
                    Souhaitez vous enregistrer vos modifications ?
                </v-card-text>
                <div class="d-flex justify-end">
                    <v-btn
                        small
                        text
                        class="text-none blue-text text-darken-4 mr-2"
                        @click.prevent="dialogs['metadata'] = false; isEditingView = false; metadataCheckbox = []"
                    >
                        Abandonner
                    </v-btn>
                    <v-btn
                        small
                        depressed
                        @click.prevent="dialogs['metadata'] = false; saveMetadata()"
                        class="text-none green accent-1 green-text text-darken-2"
                    >
                        Enregistrer
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- /Metadata dialog -->

        <!-- POI and program hotspots dialog -->
        <v-dialog
            transition="dialog-top-transition"
            max-width="500"
            v-model="dialogs['hotspot']"
        >
            <v-card class="pa-6">
                <h2 class="font-weight-bold pb-4">
                    Sauvegarder les modifications
                </h2>
                <v-card-text>
                    Souhaitez vous enregistrer vos modifications ?
                </v-card-text>
                <div class="d-flex justify-end">
                    <v-btn
                        small
                        text
                        class="text-none blue-text text-darken-4"
                        @click.prevent="resetAllHotspotPosition()"
                    >
                        Abandonner
                    </v-btn>
                    <v-btn
                        small
                        depressed
                        @click.prevent="saveHotspots()"
                        class="text-none green accent-1 green-text text-darken-2"
                    >
                        Enregistrer
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- /Metadata dialog -->

        <!-- Saved metadata snackbar -->
        <v-snackbar
            v-for="(snackbar, index) in snackbars.filter(s => s.visible)"
            :key="snackbar.text"
            v-model="snackbar.visible"
            color="success"
            :timeout="snackbarTimeout"
            :style="`bottom: ${index * 60}px`"
        >
            <v-layout class="justify-center">
                {{ snackbar.text }}
            </v-layout>
        </v-snackbar>
        <!-- Saved metadatas snackbar -->
    </div>
</template>

<script>
    import _ from 'lodash';
    import Http from '@/api/data';
    import { EventBus } from '@/event-bus';

    export default {
        name: 'EditKrpano',
        props: [
            'data',
            'editProperties',
            'defaultProperties',
            'loaded',
            'updateJsonUrl',
            'krpanoHotspot',
            'widgetTitle',
            'type',
            'sceneKey',
            'link',
            'active'
        ],
        data() {
            return {
                isLoading: !this.$props.loaded,
                toolbarHeight: 67,
                activeHotspot: null,
                isEditingView: false,
                isEditingHotspot: false,
                isEditingPOI: false,
                isSettingPosition: false,
                saveSnackbar: false,
                snackbarTimeout: 3000,
                currentMetadata: {
                    'viewAngle': 0,
                    'zoomFactor': 0,
                    'north': 0
                },
                metadataCheckbox: [],
                dialogs: {
                    'metadata' : false,
                    'hotspot': false
                },
                tourWidgets: [
                    'models',
                    'configurable-tour',
                    'drone-floor-view'
                ],
                snackbars: [
                    {
                        'id': 'viewAngle',
                        'text': 'Angle de vue enregistré',
                        'visible': false
                    },
                    {
                        'id': 'zoomFactor',
                        'text': 'Niveau de zoom enregistré',
                        'visible': false
                    },
                    {
                        'id': 'north',
                        'text': 'Orientation de la boussole enregistrée',
                        'visible': false
                    },
                    {
                        'id': 'hotspot',
                        'text': 'Modifications enregistrées',
                        'visible': false
                    }
                ],
                showTooltip: {
                    'setPosition': false,
                    'resetPosition': false
                },
                editedHotspot: {},
                hotspotList: [],
                hotspotsToSave: [],
                sidebarToOpen: null
            }
        },
        computed: {
            hotspotType() {
                return this.isEditingHotspot || this.isEditingPOI ? (this.isEditingHotspot ? 'program' : 'poi') : null;
            },
            sidebarHeader() {
                return document.getElementsByClassName('edit-sidebar-header').length ? document.getElementsByClassName('edit-sidebar-header')[0].offsetHeight : 150;
            },
            listHeight() {
                return window.innerHeight - (this.sidebarHeader + this.toolbarHeight);
            },
            hasPOI() {
                return this.$props.krpanoHotspot ?  this.$props.krpanoHotspot.findIndex(hotspot => hotspot.type === 'poi') > -1 : false;
            },
            hasHotspot() {
                return this.$props.krpanoHotspot ?  this.$props.krpanoHotspot.findIndex(hotspot => hotspot.type && hotspot.type !== 'poi') > -1 : false;
            }
        },
        methods: {
            selectHotspot(index) {
                this.activeHotspot = index;
            },
            saveMetadata() {
                let metadatas = {};
                this.metadataCheckbox.forEach(metadata => {
                    metadatas[metadata] = this.currentMetadata[metadata];
                });
                let data = {};
                if (this.$props.type == 'digitalModel' || this.$props.type == 'cutawayModel'){
                    data.level = this.$props.type == 'cutawayModel' ? 'levels' : this.$props.data.levels.find(level => level.active).id;
                    if (typeof metadatas.viewAngle !== 'undefined')
                        data.angle = metadatas.viewAngle;
                    if (typeof metadatas.zoomFactor !== 'undefined')
                        data.zoom = metadatas.zoomFactor;
                    if (typeof metadatas.north !== 'undefined')
                        data.north = this.currentMetadata.viewAngle;
                    Http.postDataForm(this.$props.updateJsonUrl, data).then(payload => {
                        // console.log(payload);
                    }).catch(error => {
                        EventBus.$emit('setErrorState', true, error);
                    });
                }
                else {

                    let data = { 'metadata': metadatas };
                    switch (this.$props.type) {
                        case 'configurable-tour':
                            data['id'] = this.$props.sceneKey
                            break;
                        default:
                            data['key'] = this.$props.sceneKey;
                            break;
                    }

                    this.saveJson(data, () => {
                        this.metadataCheckbox.forEach(metadata => {
                            if (metadata === 'north')
                                EventBus.$emit('setNorth');

                            this.snackbars.forEach(snackbar => {
                                if (metadata === snackbar.id)
                                    snackbar.visible = true;
                            });
                            this.$emit('set-camera', data);
                        });
                        this.metadataCheckbox = [];
                        if (this.sidebarToOpen)
                            this.openRequestedSidebar();
                    });
                }

            },
            saveHotspots() {
                if (this.hotspotsToSave.length) {
                    this.dialogs['hotspot'] = false;
                    let hotspotList = {};
                    hotspotList[this.hotspotType] = this.hotspotsToSave;

                    let data = {
                        'scene': this.$props.sceneKey,
                        'hotspots': this.hotspotsToSave
                    };

                    this.saveJson(data, () => {
                        this.snackbars.find(snackbar => snackbar.id === 'hotspot').visible = true;
                        this.$props.krpanoHotspot.forEach(hotspot => {
                            hotspot.canMove = false;
                        });
                        this.activeHotspot = null;
                        this.hotspotsToSave = [];
                        this.editedHotspot = {};
                        this.storeHotspotList();
                        if (this.sidebarToOpen)
                            this.openRequestedSidebar();
                    });
                }
            },
            saveJson(data, callback) {
                Http.postData(this.$props.updateJsonUrl, data).then(payload => {
                    callback();
                });
            },
            resetHotspotPosition(index) {
                let currentHotspot = this.$props.krpanoHotspot[index];
                let initialStateHotspot = this.hotspotList[index];
                this.hotspotsToSave = this.hotspotsToSave.filter(hotspot => hotspot.id !== currentHotspot.id);

                this.editedHotspot = null;
                this.activeHotspot = null;
                currentHotspot.canMove = false;
                currentHotspot.highlight = false;

                let initialAtv = initialStateHotspot.atv !== null ? initialStateHotspot.atv : 0;
                let initialAth = initialStateHotspot.ath !== null ? initialStateHotspot.ath : 0;

                currentHotspot.move(initialAtv, initialAth);
                currentHotspot.ath = initialAth;
                currentHotspot.atv = initialAtv;
                currentHotspot.visible = this.getHotspotVisibility(index);
            },
            getHotspotVisibility(index) {
                let currentHotspot = this.$props.krpanoHotspot[index];
                let initialStateHotspot = this.hotspotList[index];
                let ath = currentHotspot.ath;
                let atv = currentHotspot.atv;
                let isDisabled = currentHotspot.hasOwnProperty('active') && !currentHotspot.active;
                if (((ath == null || ath == 0) && (atv == null || atv == 0)) || isDisabled)
                    return false;
                else
                    return initialStateHotspot.visible;
            },
            toggleEditView() {
                if (this.hotspotsToSave.length) {
                    this.dialogs['hotspot'] = true;
                    if (!this.isEditingView)
                        this.sidebarToOpen = 'view';
                } else if (this.metadataCheckbox.length) {
                    this.dialogs['metadata'] = true;
                } else {
                    this.isEditingView = !this.isEditingView;
                    this.isEditingPOI = false;
                    this.isEditingHotspot = false;
                }
            },
            togglePoiSidebar() {
                if (this.hotspotsToSave.length) {
                    this.dialogs['hotspot'] = true;
                    if (!this.isEditingPOI)
                        this.sidebarToOpen = 'poi';
                } else if (this.metadataCheckbox.length) {
                    this.dialogs['metadata'] = true;
                    if (!this.isEditingPOI)
                        this.sidebarToOpen = 'poi';
                } else {
                    this.isEditingPOI = !this.isEditingPOI;
                    this.isEditingHotspot = false;
                    this.isEditingView = false;
                }
            },
            toggleProgramHotspotSidebar() {
                if (this.hotspotsToSave.length) {
                    this.dialogs['hotspot'] = true;
                    if (!this.isEditingHotspot)
                        this.sidebarToOpen = 'hotspot';
                } else if (this.metadataCheckbox.length) {
                    this.dialogs['metadata'] = true;
                    if (!this.isEditingPOI)
                        this.sidebarToOpen = 'hotspot';
                }  else {
                    this.isEditingHotspot = !this.isEditingHotspot;
                    this.isEditingPOI = false;
                    this.isEditingView = false;
                }
            },
            resetAllHotspotPosition() {
                this.dialogs['hotspot'] = false;
                this.isEditingHotspot = false;
                this.isEditingPOI = false;
                let initialStateHotspot;
                this.$props.krpanoHotspot.forEach((hotspot, index) => {
                    initialStateHotspot = this.hotspotList[index];
                    hotspot.move(initialStateHotspot.atv, initialStateHotspot.ath);
                    hotspot.ath = initialStateHotspot.ath;
                    hotspot.atv = initialStateHotspot.atv;
                    hotspot.highlight = false;
                    hotspot.canMove = false;
                });
                this.hotspotsToSave = [];
                if (this.sidebarToOpen)
                    this.openRequestedSidebar();
            },
            storeHotspotList() {
                this.hotspotList = _.cloneDeep(this.$props.krpanoHotspot); 
            },
            openRequestedSidebar() {
                if (this.sidebarToOpen === 'poi') {
                    this.isEditingView = false;
                    this.isEditingHotspot = false;
                    this.isEditingPOI = true;
                }
                else if (this.sidebarToOpen === 'hotspots') {
                    this.isEditingView = false;
                    this.isEditingHotspot = true;
                    this.isEditingPOI = false;
                }
                else {
                    this.isEditingView = true;
                    this.isEditingHotspot = false;
                    this.isEditingPOI = false;
                }

                this.sidebarToOpen = null;
            }
        },
        watch: {
            'defaultProperties.viewAngle'() {
                this.currentMetadata.viewAngle = this.defaultProperties.viewAngle;
            },
            'defaultProperties.zoomFactor'() {
                this.currentMetadata.zoomFactor = this.defaultProperties.zoomFactor;
            },
            'defaultProperties.north'() {
                this.currentMetadata.north = this.defaultProperties.north;
            },
            'editProperties.viewAngle'(val) {
                this.currentMetadata.viewAngle = val;
            },
            'editProperties.zoomFactor'(val) {
                this.currentMetadata.zoomFactor = val;
            },
            'editProperties.north'(val) {
                this.currentMetadata.north = val;
            },
            loaded() {
                this.isLoading = !this.$props.loaded;
                this.storeHotspotList();
            },
            isEditingPOI() {
                if (!this.isEditingPOI)
                    this.activeHotspot = null;
            },
            isEditingHotspot() {
                if (!this.isEditingHotspot)
                    this.activeHotspot = null;
            },
            'krpanoHotspot': {
                handler: function(hotspotList, oldHotspotList) {
                    if ((this.isEditingPOI || this.isEditingHotspot) && this.editedHotspot) {
                        let vm = this;
                        let foundHotspot = hotspotList.filter(hotspot => hotspot.id === this.editedHotspot.id);
                        let foundOldHotspot = vm.hotspotList.filter(hotspot => hotspot.id === this.editedHotspot.id);
                        if (foundHotspot.length && foundOldHotspot.length)
                            if ((foundHotspot[0].ath !== foundOldHotspot[0].ath || foundHotspot[0].atv !== foundOldHotspot[0].atv)) {
                                foundHotspot[0].active = true;
                                var hotspotIndex = this.hotspotsToSave.length ? this.hotspotsToSave.findIndex(hotspot => hotspot.id == vm.editedHotspot.id) : -1;
                                if (hotspotIndex >= 0)
                                    this.hotspotsToSave[hotspotIndex] = Object.assign({}, this.hotspotsToSave[hotspotIndex], foundHotspot[0]); // Update hotspot properties
                                else
                                    this.hotspotsToSave.push(foundHotspot[0]);
                            }
                    }
                },
                deep: true
            },
            activeHotspot(newIndex, oldIndex) {
                let currentHotspot = this.$props.krpanoHotspot[newIndex];
                let oldHotspot = this.$props.krpanoHotspot[oldIndex];
                if (newIndex !== null) {
                    currentHotspot.canMove = true;
                    currentHotspot.highlight = true;
                    currentHotspot.visible = true;
                    if (currentHotspot.ath === null && currentHotspot.atv === null) {
                        currentHotspot.ath = 0;
                        currentHotspot.atv = 0;
                    }

                    this.editedHotspot = currentHotspot;
                }
                if (oldIndex !== null) {
                    let saveList = this.hotspotsToSave.filter(hotspot => hotspot.id === oldHotspot.id);
                    if (!saveList.length) {
                        oldHotspot.highlight = false;
                        oldHotspot.canMove = false;
                        oldHotspot.visible = this.getHotspotVisibility(oldIndex);
                    }
                }
            },
            sceneKey(newKey, oldKey) {
                if (oldKey && oldKey !== newKey) {
                    this.storeHotspotList();
                    this.hotspotsToSave = [];
                    this.editedHotspot = {};
                }
            },
            link() {
                if (this.active) {
                    if (this.editProperties.north !== null)
                        this.defaultProperties.north = this.editProperties.north;
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_edit-mode.scss";
</style>


// WEBPACK FOOTER //
// src/components/editMode/EditKrpano.vue